import { render, staticRenderFns } from "./ConfirmBookingModal.vue?vue&type=template&id=374bd2b1&scoped=true"
import script from "./ConfirmBookingModal.vue?vue&type=script&lang=js"
export * from "./ConfirmBookingModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBookingModal.vue?vue&type=style&index=0&id=374bd2b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374bd2b1",
  null
  
)

export default component.exports